import LinkRouter from "./LinkRouter";
export default LinkRouter;
